import { render, staticRenderFns } from "./IndemnityPriceClinicTemplateAddModal.vue?vue&type=template&id=6183c9b6&scoped=true"
import script from "./IndemnityPriceClinicTemplateAddModal.vue?vue&type=script&lang=js"
export * from "./IndemnityPriceClinicTemplateAddModal.vue?vue&type=script&lang=js"
import style0 from "./IndemnityPriceClinicTemplateAddModal.vue?vue&type=style&index=0&id=6183c9b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6183c9b6",
  null
  
)

export default component.exports